import {
  CARD_TYPE_VIRTUAL,
  ERROR_NOTIFICATION_TYPE,
  IMAGE_HEIGHT,
  IMAGE_WIDTH,
  MEDIA_PATH,
  MEDIA_RESIZE_ACTION,
  OPTIONS_KEY,
  OPTION_FIELDS,
  PRODUCT_TYPE,
  TOTAL_SEGMENT_CODE,
  TOTAL_SEGMENT_SEPARATOR
} from '../constants'
import { AppliedGiftCards, GiftCardForm, GiftCardImage } from '../types/GiftCard'

export const isGiftCardProduct = (product): boolean => Boolean(product) && product.type_id === PRODUCT_TYPE

export const isGiftCardAddedToCart = (diffLog, cartItems = []): boolean => {
  const notifications = (diffLog && diffLog.clientNotifications) || []
  const hasError = notifications.some(notification => notification.type === ERROR_NOTIFICATION_TYPE)

  return !hasError && (cartItems || []).some(isGiftCardProduct)
}

export const getGiftCardImageUrl = (image: GiftCardImage): string =>
  `${MEDIA_PATH}${MEDIA_RESIZE_ACTION}/${IMAGE_WIDTH}/${IMAGE_HEIGHT}/${image.path}`

export const buildGiftCardOptions = (form: GiftCardForm) => ({
  ...(form.isCustomAmount
    ? { [OPTION_FIELDS.customAmount]: form.amount }
    : { [OPTION_FIELDS.amount]: form.amount }),
  [OPTION_FIELDS.type]: CARD_TYPE_VIRTUAL,
  [OPTION_FIELDS.image]: form.imageId,
  [OPTION_FIELDS.senderName]: form.senderName.trim(),
  [OPTION_FIELDS.recipientName]: form.recipientName.trim(),
  [OPTION_FIELDS.recipientEmail]: form.recipientEmail.trim(),
  [OPTION_FIELDS.message]: form.message.trim()
})

export const buildGiftCardCartItem = (product, form: GiftCardForm) => ({
  ...product,
  qty: 1,
  price: form.amount,
  price_incl_tax: form.amount,
  priceInclTax: form.amount,
  final_price: form.amount,
  original_price: form.amount,
  product_option: {
    extension_attributes: {
      [OPTIONS_KEY]: buildGiftCardOptions(form)
    }
  }
})

export const getAppliedGiftCards = (totals = []): AppliedGiftCards => {
  const segment = (totals || []).find(total => total.code === TOTAL_SEGMENT_CODE)

  if (!segment || !segment.title) {
    return { codes: [], amount: 0 }
  }

  return {
    codes: String(segment.title).split(TOTAL_SEGMENT_SEPARATOR).filter(Boolean),
    amount: Math.abs(Number(segment.value) || 0)
  }
}

export const buildGiftCardTotalSegment = (giftCardOrder) => {
  const amount = Number(giftCardOrder && giftCardOrder.gift_amount) || 0

  if (amount <= 0) {
    return null
  }

  const codes = ((giftCardOrder && giftCardOrder.gift_cards) || []).map(card => card.code).filter(Boolean)

  return { code: TOTAL_SEGMENT_CODE, title: codes.join(TOTAL_SEGMENT_SEPARATOR), value: -amount }
}
